
const AddNewAppPopup = () => import('../components/App/AddNewApp/AddNewAppPopup.vue');
const BlockSubAccountsPopup = () => import('../components/Campaign/Popups/BlockSubAccountsPopup.vue');
const UnblockSubAccountsPopup = () => import('../components/Campaign/Popups/UnblockSubAccountsPopup.vue');
const SelectKpiEventsPopupPopup = () => import('../components/Campaign/Popups/SelectKpiEventsPopup.vue');

const popupTypes = {
    ADD_NEW_APP: AddNewAppPopup,
    BLOCK_SUB_ACCOUNTS: BlockSubAccountsPopup,
    UNBLOCK_SUB_ACCOUNTS: UnblockSubAccountsPopup,
    SELECT_KPI_EVENTS: SelectKpiEventsPopupPopup
};

export default popupTypes;



// WEBPACK FOOTER //
// ./src/consts/popupTypes.js